import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import Footer from '../../../../../components/footer'
import Head from '../../../../../components/head';
import FormCad from '../../../../../components/auth/saude/profissionais/form_cad'


function CadastrarProfissionaisaudeScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar Profissional da Secretaria Municipal de Saúde" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarProfissionaisaudeScreen;